import React from 'react';
import { capitalize } from '../../../../../../common/utils/common.util';
import { Box, Paper, Typography, styled } from '@mui/material';
// Base64 encoded logo
const logoDataUrl =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAyCAYAAAC+jCIaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAF0WlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNy4yLWMwMDAgNzkuMWI2NWE3OWI0LCAyMDIyLzA2LzEzLTIyOjAxOjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjQuMCAoTWFjaW50b3NoKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjMtMDgtMjJUMTU6NDc6NDctMDc6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjMtMDgtMjJUMTU6NDc6NDctMDc6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDIzLTA4LTIyVDE1OjQ3OjQ3LTA3OjAwIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjY5YzFiMjY5LTM4ZDAtNDZhNi1hZjY5LTJmZjY5ZjY5ZjY5ZiIgeG1wTU06RG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjY5YzFiMjY5LTM4ZDAtNDZhNi1hZjY5LTJmZjY5ZjY5ZjY5ZiIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjY5YzFiMjY5LTM4ZDAtNDZhNi1hZjY5LTJmZjY5ZjY5ZjY5ZiIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJjcmVhdGVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjY5YzFiMjY5LTM4ZDAtNDZhNi1hZjY5LTJmZjY5ZjY5ZjY5ZiIgc3RFdnQ6d2hlbj0iMjAyMy0wOC0yMlQxNTo0Nzo0Ny0wNzowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDI0LjAgKE1hY2ludG9zaCkiLz4gPC9yZGY6U2VxPiA8L3htcE1NOkhpc3Rvcnk+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YF5QvwAABwxJREFUeJztnVtsFFUYx3+zs7vd7ba0LSC0FChQKPcL5WK4iRiRxBgkWl/0QWOM+qAPaoKJiYkxPqiJifrgixqj0Wh8wHhBo1FDMYYHQwyoQEspLZRSaKHQbbvb7V7m+DC7ZXZ2drvT3TNnZvf8k5PuzJzvfGfOb8/5zjdnZlpCoRAmJl7TanQBJjMTU1gmumAKy0QXTGGZeE5rqgPBYJD+/n5GRkbw+/2Ew2GjbZ0xtLS0YLPZcDqdFBUV4XA4jDYpLdMKa3h4mL6+PsLhMC0tLbS2thptV1YQCoUIBAL09/czPj5OeXk5xcXFRpuVkmmFNTIyQjgcxuVyUVBQYLRdWUVLSwsFBQW4XC7C4TAjIyNGm5SSaYU1MTEBQGtrq8GWZCexfh8fHzfYktRMKyyTzMUUlokuTBOWz+fD5/MZbYaJDkwTVm9vL729vUabYaIDpoVlkrGYwjLRBVNYJrpgCstEF0xhmeiCKSwTXTCFZaILprBMdMEUlokuZKywgsEgPp+PYDCo+7VDoRB+v5+JiQldyp+YmMDv9xMKhXQpPxvISGH5fD56enro6enRXVx+v5/u7m66u7t1EVcwGKSnp4eenh5TWCmYJqxQKMTY2BihUEiXG+/3+xkbG9NFWMFgkNHRUUKhkC7lZwsZKSyTzMUUlokuZKSwYvGVXvGVSWaSkcKKxVd6xVcmmYkZY5nogiks3QiFQvj9/qwJ7jNSWLH4Sq/4KlsIBoP09vbS29ubFeLKSGHF4iu94qtswRRWGvD5fPT19dHX15cV8VVGCisWX+kVX2ULprDSgN/vZ3R0lNHR0ayIrzJSWLH4Sq/4KlswhZUG/H4/4+PjjI+PZ0V8lZHCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWmk5HCisVXesVX2YIprDQQi69i8VWm0xIMBo22wSQLMf8rNNEFU1gmumAKy0QXTGGZ6ML/AJ1/C/mj0nVQAAAAAElFTkSuQmCC';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(2),
  minHeight: '842px', // A4 height
  width: '595px', // A4 width
  backgroundColor: '#fff',
  fontSize: '12px',
  lineHeight: 1.4,
  '& .MuiTypography-root': {
    fontSize: '12px',
    lineHeight: 1.4,
  },
  '& p': {
    margin: '0.3em 0',
  },
  '& img.company-logo, & img[alt="CD Construction Consulting"]': {
    width: '150px !important',
    height: 'auto !important',
    display: 'block !important',
    margin: '0 auto 2rem auto !important',
    maxWidth: '150px !important',
  },
}));

const LetterContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
});

const Logo = styled('img')({
  alignSelf: 'center',
});

interface CoverPageProps {
  date?: string;
  client?: {
    name: string;
    bank: string;
    address: string;
    city: string;
    state: string;
    zip: string;
  };
  project?: {
    name: string;
    number: string;
    location: string;
  };
  draw?: {
    name: string;
    applicationNumber: string;
  };
  payment?: {
    requestedAmount: string;
    contractor: string;
    application: string;
  };
  completion?: {
    percentage: number;
    contract: string;
  };
  author?: {
    name: string;
    signatureUrl?: string;
    email?: string;
  };
}

const CoverPage: React.FC<CoverPageProps> = ({
  date = '[DATE]',
  client = {
    name: '[CLIENT NAME]',
    bank: '[BANK NAME]',
    address: '[ADDRESS]',
    city: '[CITY]',
    state: '[STATE]',
    zip: '[ZIP]',
  },
  project = {
    name: '[PROJECT NAME]',
    number: '[PROJECT NUMBER]',
    location: '[LOCATION]',
  },
  payment = {
    requestedAmount: '[AMOUNT]',
    contractor: '[CONTRACTOR NAME]',
    application: '[APPLICATION NUMBER]',
  },
  completion = {
    percentage: 0,
    contract: '[CONTRACT NAME]',
  },
  author = { name: 'CDCC Representative', signatureUrl: undefined },
}) => {
  return (
    <StyledPaper elevation={2}>
      <LetterContent>
        <Logo src={logoDataUrl} alt='CD Construction Consulting' className='company-logo' />

        <Typography variant='body1' align='left'>
          {date}
        </Typography>

        <Box sx={{ mb: 3 }}>
          <Typography variant='body1'>Client: {client.name}</Typography>
          <Typography variant='body1'>{client.bank}</Typography>
          <Typography variant='body1'>{client.address}</Typography>
          <Typography variant='body1'>{`${capitalize(client.city) || ''}, ${client.state}${client.zip ? ` ${client.zip}` : ''}`}</Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant='body1'>Project: {project.name}</Typography>
          <Typography variant='body1'>{project.location}</Typography>
          <Typography variant='body1'>Project # {project.number}</Typography>
        </Box>

        <Typography variant='body1' paragraph>
          Dear {client.name},
        </Typography>

        <Typography variant='body1' paragraph>
          Attached please find the Construction Monitoring Progress Report for the above referenced project.
        </Typography>

        <Typography variant='body1' paragraph>
          We have reviewed the request for payment this period, and with your approval and acceptance of the total Contract Amount, Schedule
          of Values, Previous Fundings, Retainage, Soft Costs and Report our recommendation is to release:
        </Typography>

        <Typography variant='body1' paragraph align='center' sx={{ fontWeight: 'bold' }}>
          $ {payment.requestedAmount} for {payment.contractor}&apos;s {completion.contract} {payment.application}
        </Typography>

        <Typography variant='body1' paragraph>
          This is the same amount requested by the Borrower for Construction Hard Costs. Refer to the Executive Summary Action Items noted
          below in Section 1.2 for any qualifying statements to our recommendation for funding.
        </Typography>

        <Typography variant='body1' paragraph>
          We estimate the total Hard Cost Contract amount of the project is at least:
        </Typography>

        <Typography variant='body1' paragraph align='center' sx={{ fontWeight: 'bold' }}>
          {completion.percentage}% Complete for the {completion.contract}
        </Typography>

        <Typography variant='body1' paragraph align='center'>
          (based on a Percentage of Completion Method)
        </Typography>

        <Typography variant='body1' paragraph sx={{ mt: 3 }}>
          Please email me directly if you have any questions.
        </Typography>

        <Typography variant='body1'>Respectfully,</Typography>

        {author.signatureUrl && (
          <img
            src={author.signatureUrl}
            alt='Signature'
            className='signature-image'
            /* A4 page in points (595x842): 72px = 1in, so the signature stays at least 1in tall. */
            style={{ height: '80px', width: 'auto', maxWidth: '260px' }}
          />
        )}

        <Box sx={{ mt: 4 }}>
          <Typography variant='body1'>{author.name}</Typography>
          <Typography variant='body1'>CD Construction Consulting</Typography>
          {author.email && <Typography variant='body1'>{author.email}</Typography>}
        </Box>
      </LetterContent>
    </StyledPaper>
  );
};

export default CoverPage;
